import Icon from '../components/Icon.vue'

Icon.register({
  underline: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224.3 388.2c-91.7 0-156.6-51.2-156.6-151.4v-172.8h-28.3c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h137.4c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-28.8v172.8c0 53.7 28.3 79.4 76.3 79.4 47 0 75.8-25.4 75.8-80v-172.3h-28.3c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h136.9c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-28.3v172.8c0 99.4-64.9 151.4-156.1 151.4zM16 448h416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z'
      }
    ]
  }
})
